import type { FaireProductEntity } from "../../entity_types/product";

export const p_pua3j7t498: FaireProductEntity = {
  token: "p_pua3j7t498",
  type: "product",
  name: "Nervous System Reset Tincture, 2oz",
  brandToken: "b_zqh3u776ct",
  brandName: "Evergreen Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/0e63c47c830f77e5849f15ea3d7e35b45790923fedc6582adeb79846a1bff3d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a37213832c9abd2a80f06d07c931e73032a07ca5398d55c821b3081bd1c4a1c.jpeg",
    "https://cdn.faire.com/fastly/a1d03bcb944a3dff975d67e56c9cb1954faf567a5e96e55288e8b5b0e57b31ca.jpeg",
    "https://cdn.faire.com/fastly/4e71397080ffe5361d8deb73ccdc19171526abff61e507c6ae18cee60077d482.jpeg",
    "https://cdn.faire.com/fastly/d10eb60722a80ff471a17275bd734b24239c1ddd8a3e40b79426756e590daf58.jpeg",
    "https://cdn.faire.com/fastly/c66e3dee3e0644d64dcb412828d12e3477b09a1f83fca56561ca53fbfb9b1c7d.jpeg",
    "https://cdn.faire.com/fastly/fe6f001725fe4edabb0fbf3ce97a00ee9c08d5c32be0950c40699433fef61bd2.jpeg",
    "https://cdn.faire.com/fastly/1723cd78e4765a1e152ee5597390b6b589f57145bd559284fc2357e449412814.jpeg",
    "https://cdn.faire.com/fastly/f4d782ba449bc51fb7715b8842eacd4583acb4a0bd04b392da75d1bb3b2ed0db.jpeg",
    "https://cdn.faire.com/fastly/42c63439c0d6b96e80adfee9b9f3fac77cc262230a12021b3679b6e7b158891f.jpeg",
    "https://cdn.faire.com/fastly/ad65ff9b0f89339d369dadd281a107cbdf65a08c786019e3addc3526e5129080.jpeg",
  ],
  priceDollars: 13,
  description:
    "This tincture is formulated to restore balance, resilience, and calm the body's overstimulated or dysregulated nervous system. In today's high stress world, this kind of support can be deeply beneficial. \n-Chronic stress, trauma, anxiety, and even burnout can leave the nervous system in fight or flight mode, leading to fatigue, poor sleep, and trouble concentrating. Nervine herbs gently soothe the system and help shift it back into rest and relaxation. \n\nOut of stock? Feel free to message us!\nLooking for white label? Message us and we are happy to work with you.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:48.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
